import { render } from "./ProductFiltersDetail.vue?vue&type=template&id=44041eec&scoped=true&ts=true"
import script from "./ProductFiltersDetail.vue?vue&type=script&lang=ts"
export * from "./ProductFiltersDetail.vue?vue&type=script&lang=ts"

import "./ProductFiltersDetail.vue?vue&type=style&index=0&id=44041eec&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44041eec"]])

export default __exports__